import { Cookies } from 'react-cookie-consent';
import { ANALYTICS_COOKIES, MEET_COOKIES } from '../const';

const domain = `${window.location.hostname.replace(/^[^.]*\.(?=\w+\.\w+$)/, '')}`;

const cookieOptions = {};
cookieOptions.expires = 90;
if (domain && domain !== 'localhost') {
  cookieOptions.domain = `.${domain}`;
}

export const getConsentCookie = user => {
  return Cookies.get(`CookieConsent_${user._id}`);
};

export const setConsentCookie = (user, value) => {
  Cookies.set(`CookieConsent_${user._id}`, value, cookieOptions);
};

export const getVideoCookie = user => {
  return Cookies.get(`videoConsent_${user._id}`);
};

export const getAnalyticsCookie = user => {
  return Cookies.get(`analyticsConsent_${user._id}`);
};

export const setAnalyticsCookie = (user, value) => {
  Cookies.set(`analyticsConsent_${user._id}`, value, cookieOptions);
};

export const getMeetCookie = user => {
  return Cookies.get(`meetConsent_${user._id}`);
};

export const setMeetCookie = (user, value) => {
  Cookies.set(`meetConsent_${user._id}`, value, cookieOptions);
};

export const setVideoCookie = (user, value) => {
  Cookies.set(`videoConsent_${user._id}`, value, cookieOptions);
};

export const removeAnalyticsGenericCookies = () => {
  removeCookies(ANALYTICS_COOKIES);
};

export const removeMeetGenericCookies = () => {
  removeCookies(MEET_COOKIES);
};

export const removeCookies = (cookies, user) => {
  if (cookies) {
    if (user) {
      cookies = cookies.filter(c => c.endsWith(user._id));
    }
    cookies.forEach(c => (document.cookie = c + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;'));

    const hostname = window.location.hostname;
    const firstDomainPart = hostname.split('.').shift();
    const domain = window.location.hostname.replace(firstDomainPart, '');

    if (domain !== '') {
      cookies.forEach(
        c => (document.cookie = c + '=; Path=/; Domain=.' + hostname + '; Expires=Thu, 01 Jan 1970 00:00:01 GMT;')
      );
      cookies.forEach(
        c => (document.cookie = c + '=; Path=/; Domain=' + domain + '; Expires=Thu, 01 Jan 1970 00:00:01 GMT;')
      );
    }
  }
};
